module.exports = __webpack_public_path__ + "static/media/11NEPAD2.8b81b0a8.jpg";